import st from './styles.module.scss';

interface Props {
  onSelected: () => void;
}

export const SelectAllButton: React.FC<Props> = ({ onSelected }) => {
  return (
    <button className={st.allBtn} onClick={onSelected}>
      Выбрать всё
    </button>
  );
};
